"use client";

import PageLoader from "@/app/(components)/generics/loaders/PageLoader/PageLoader";
import Project from "@/app/(components)/specifics/projet/Project/Project";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import { useBrand } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { ProjectStore } from "@/app/stores/ProjectStore";
import { PageProps } from "@/app/types/common/PageProps";
import { PageBootstrap } from "@/app/types/common/WorkspaceSelection";
import { ProjectWorkspace } from "@/app/types/project/ProjectWorkspace";
import Meidly from "./Meidly/Meidly";
import TenantGate from "./TenantGate/TenantGate";

type Props = PageProps & {
  bootstrap: PageBootstrap<ProjectWorkspace> | null;
};

export default function Home(props: Props) {
  const user = useAuthUser();
  const tenant = useBrand();
  const currentProject = ProjectStore((state) => state.currentProject);

  if (user) {
    if (!currentProject) {
      return <PageLoader />;
    }
    return <Project params={props.params} project={currentProject} bootstrap={props.bootstrap} />;
  }

  if (tenant) {
    return <TenantGate {...props} />;
  }

  return <Meidly {...props} />;
}
